<!--
 * @Description: 全部人选-Item
 * @Author: black-k
 * @Date: 2025-09-08 13:58:36
 * @LastEditors: black-k
 * @LastEditTime: 2025-09-22 14:47:19
-->
<template>
    <div :class="['plan-item', { shadow: shadow }]">
        <!-- 用户头部信息 -->
        <div class="plan-item_header">
            <div class="header-info">
                <img :src="getAvatar(plan.user_info?.head_portrait)" alt="" />

                <div class="info-detail">
                    <div class="detail-company">
                        <h2>{{ plan.user_info?.name }}</h2>

                        <!-- 好评率 -->
                        <span class="rate">
                            好评率：<i>{{ plan?.user_rating || 0 }}%</i>
                        </span>

                        <!-- 提交记录 -->
                        <el-popover
                            placement="bottom"
                            width="520"
                            trigger="click"
                            popper-class="submit-history-popper"
                            v-if="isShowHistory"
                        >
                            <div class="submit-history" slot="reference">
                                第{{ plan.applications_history?.length }}次提交
                                <i class="el-icon-arrow-down"></i>
                            </div>

                            <!-- 提交记录列表 -->
                            <div class="submit-list">
                                <div class="submit-item flex-center" v-for="(item, index) in plan.applications_history">
                                    <div class="submit-item_label">第{{ index + 1 }}次提交</div>
                                    <div class="submit-item_time">{{ plan.create_time }}{{ taskMode === 1 ? "报名" : "交稿" }}</div>
                                    <el-button type="text" class="submit-item_btn" @click="handleHistoryDetail(item, index)">
                                        查看详情
                                    </el-button>
                                </div>
                            </div>
                        </el-popover>
                    </div>

                    <div class="detail-time">{{ plan.create_time }}{{ taskMode === 1 ? "报名" : "交稿" }}</div>
                </div>
            </div>

            <div class="header-operate" v-if="plan.status === 0 && operates">
                <div class="operate-btn flex-center" @click="handleAction('fail')">淘汰</div>
                <div class="operate-btn flex-center normal" @click="handleAction('backup')">备选</div>
                <div class="operate-btn flex-center primary" @click="handleAction('win-bid')">设为中标</div>
            </div>
        </div>

        <!-- 展示计划内容 -->
        <template v-if="isShowPlan">
            <!-- 理由 -->
            <div class="plan-item_reason" v-if="[2, 3].includes(plan.status) && plan.reply">
                <div :class="['reason-box', `reason-${plan.status}`]">
                    <div class="reason-label">
                        <i class="el-icon-warning"></i>
                        {{ plan.status === 2 ? "修改意见" : "淘汰理由" }}:
                    </div>

                    <div class="reason-desc">
                        <div class="desc-item" v-for="(item, index) in plan.reply.split('\n')" :key="index">
                            {{ item }}
                        </div>
                    </div>
                </div>
            </div>

            <!-- 计划详情 -->
            <div class="plan-item_detail">
                <!-- 报价 -->
                <div class="detail-item money" v-if="taskMode === 1">
                    <div class="detail-item_label">报价：</div>
                    <div class="detail-item_value">{{ plan.price }}金币</div>
                </div>

                <!-- 描述 -->
                <div class="detail-item desc">
                    <div class="detail-item_label">说明：</div>
                    <div class="detail-item_value">
                        <div class="desc-empty" v-if="!plan.description">无说明内容</div>

                        <div class="desc-ol" v-else>
                            <div class="ol-item" v-for="item in plan.description.split('\n')">
                                {{ item }}
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 链接 -->
                <div class="detail-item link" v-if="plan.urls && plan.urls.length > 0">
                    <div class="detail-item_label">链接：</div>

                    <div class="detail-item_value">
                        <div class="link-item" v-for="link in plan.urls" @click="handleLink(link)">
                            <el-link type="primary">
                                <i class="el-icon-link"></i>
                                {{ link.name }}
                            </el-link>
                        </div>
                    </div>
                </div>

                <!-- 附件 -->
                <div class="detail-item files" v-if="plan.files?.length > 0">
                    <div class="detail-item_label">附件：</div>

                    <div class="detail-item_value">
                        <ul class="files-ul">
                            <template v-for="(file, index) in plan.files">
                                <li :key="index" @click="handleDown(file)">
                                    <img :src="getIcon(file.file_name)" alt="" />
                                    {{ file.file_name }}

                                    <i class="el-icon-download"></i>
                                </li>

                                <!-- 视频 -->
                                <video :src="file.file_url" v-if="isVideo(file.file_name) && video" controls></video>
                            </template>
                        </ul>
                    </div>
                </div>
            </div>
        </template>

        <!-- 设置隐私 -->
        <div class="plan-item_privacy flex-center" v-else>
            <div class="privacy-line"></div>
            <div class="privacy-tip flex-center">
                <i class="el-icon-lock"></i>
                {{ `该${taskMode === 1 ? "报名内容" : "稿件"}已设置隐私保护，仅需求方可见` }}
            </div>
            <div class="privacy-line"></div>
        </div>

        <!-- 中标淘汰等状态 -->
        <img :src="getStatusIcon(plan.status)" alt="" class="status-icon" v-if="plan.status !== 0 && history" />

        <HistoryDialog
            :visible.sync="historyDialog.visible"
            :plan="historyDialog.plan"
            :index="historyDialog.index"
            :mode="taskMode"
            :user-id="userId"
            v-if="history"
        ></HistoryDialog>
    </div>
</template>

<script>
import { downloadFile, getFileIcon, getFileUnit } from "@/utils/common";
import HistoryDialog from "../dialog/HistoryDialog.vue";

export default {
    name: "PlanItem",

    data() {
        return {
            role: Number(localStorage.getItem("role")), // 角色 5-企业，4-学生
            user_id: Number(localStorage.getItem("id")), // 账号id

            historyDialog: {
                visible: false,
                index: 1,
                plan: undefined,
            },
        };
    },

    props: {
        plan: {
            type: Object,
            required: true,
        },

        operates: {
            type: Boolean,
            default: true,
        },

        taskMode: {
            type: Number,
            default: 1,
        },

        history: {
            type: Boolean,
            default: true,
        },

        shadow: {
            type: Boolean,
            default: true,
        },

        video: {
            type: Boolean,
            default: true,
        },

        userId: {
            type: Number,
        },
    },

    components: {
        HistoryDialog,
    },

    computed: {
        isAdmin() {
            return [1, 2].includes(this.role);
        },

        // 是否是自己的项目
        isOwnTask() {
            return Number(localStorage.getItem("id")) === this.userId || this.isAdmin;
        },

        isShowPlan() {
            // 不是学生，直接展示内容
            if (this.role !== 4) {
                return this.isOwnTask;
            } else {
                // 学生
                const isOwn = Number(localStorage.getItem("id")) === this.plan?.user_id; // 是否是自己的报名信息

                // 招募模式只能看自己的, 竞单模式如果没设置隐私也可查看
                return this.taskMode === 1 ? isOwn : isOwn || this.plan?.is_privacy !== 1; // 自己的，或者没有设置隐藏
            }
        },

        // 是否展示提交记录
        isShowHistory() {
            if (!this.history) return false;

            const isHistory = this.plan?.applications_history?.length > 0; // 是否有提交历史

            // 不是学生，
            if (this.role !== 4) return this.isOwnTask && isHistory;

            // 学生-不是自己的不显示
            return this.user_id === this.plan.user_id ? isHistory : false;
        },
    },

    methods: {
        // 获取文件Icon
        getIcon(name) {
            return getFileIcon(getFileUnit(name));
        },

        // 获取学生头像
        getAvatar(avatar) {
            return avatar || require("@/assets/img/image/user_img.png");
        },

        // 获取状态icon
        getStatusIcon(status) {
            const statusIconMap = {
                1: require("@/assets/img/task-center/check-icon.png"),
                2: require("@/assets/img/task-center/backup-icon.png"),
                3: require("@/assets/img/task-center/fail-icon.png"),
            };

            return statusIconMap[status];
        },

        isVideo(name) {
            return getFileUnit(name) === "mp4";
        },

        // 打开链接
        handleLink(link) {
            window.open(link.url, "_blank");
        },

        // 下载文件
        async handleDown(file) {
            downloadFile(file.file_url, file.file_name);
        },

        handleAction(type) {
            if (type === "win-bid" && this.bidDisabled) return;

            this.$emit("action", type, this.plan);
        },

        // 查看历史详情
        handleHistoryDetail(plan, index) {
            this.historyDialog.plan = plan;
            this.historyDialog.index = index + 1;
            this.historyDialog.visible = true;
        },
    },
};
</script>

<style lang="scss" scoped>
.plan-item {
    margin-top: 20px;
    background-color: #ffffff;
    position: relative;

    &.shadow {
        box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
    }

    &_header {
        padding: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #e9e9e9;

        .header-info {
            display: flex;
            align-items: center;
            gap: 20px;

            img {
                width: 60px;
                height: 60px;
                object-fit: cover;
                border-radius: 4px;
            }

            .info-detail {
                .detail-company {
                    display: flex;
                    align-items: center;
                    gap: 20px;

                    h2,
                    div,
                    span {
                        font-weight: 500;
                        font-size: 14px;
                    }

                    h2 {
                        font-size: 18px;
                        color: #333333;
                        margin: 0;
                    }

                    .rate {
                        color: #999999;

                        i {
                            color: #ff8a00;
                            font-style: normal;
                        }
                    }

                    .submit-history {
                        color: #1890ff;
                        cursor: pointer;
                    }
                }

                .detail-time {
                    margin-top: 5px;
                    font-weight: 400;
                    font-size: 14px;
                    color: #999999;
                }
            }
        }

        .header-operate {
            display: flex;
            align-items: center;
            gap: 20px;

            .operate-btn {
                width: 88px;
                height: 32px;
                background: #f4f5f5;
                border-radius: 20px;
                font-weight: 400;
                font-size: 14px;
                color: #6b7075;
                cursor: pointer;

                &.normal {
                    background: rgba(84, 74, 236, 0.2);
                    color: #554aec;
                }

                &.primary {
                    background: linear-gradient(270deg, #594fed 0%, #291ce7 100%);
                    color: #ffffff;
                }

                &.disabled {
                    opacity: 0.5;
                    cursor: not-allowed;
                }
            }
        }
    }

    &_reason {
        padding: 20px 40px 0;

        .reason-box {
            --bg-color: #fffbf8;
            --border-color: #ed7b2f;
            --color: #ed7b2f;
            padding: 16px;
            background-color: var(--bg-color);
            border-radius: 4px 4px 4px 4px;
            border: 1px solid var(--border-color);
            font-weight: 400;
            font-size: 14px;
            color: #333a40;
            display: flex;

            .el-icon-warning {
                color: var(--color);
            }

            .reason-label {
                flex-shrink: 0;
            }

            .reason-desc {
                margin-left: 8px;

                .desc-item {
                    min-height: 20px;
                }
            }

            &.reason-3 {
                --bg-color: #fff2f2;
                --border-color: #ff9595;
                --color: #ff3c3c;
            }
        }
    }

    &_detail {
        padding: 20px 40px 20px 100px;

        .detail-item {
            & + .detail-item {
                margin-top: 20px;
            }

            display: flex;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #333333;

            &_label {
                flex-shrink: 0;
            }

            &.money {
                .detail-item_value {
                    color: #ff8a00;
                }
            }

            &.desc {
                .desc-empty {
                    font-weight: 400;
                    color: #999999;
                }

                .desc-ol {
                    padding: 0;
                    margin: 0;

                    .ol-item {
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;
                        min-height: 20px;
                    }
                }
            }

            &.link {
                ::v-deep(.el-link) {
                    color: #1890ff;
                    display: flex;
                    justify-content: flex-start;
                }
            }

            &.files {
                .files-ul {
                    li {
                        & + li {
                            margin-top: 16px;
                        }

                        display: flex;
                        align-items: center;
                        gap: 3px;
                        color: #1890ff;
                        font-weight: 400;
                        font-size: 14px;
                        cursor: pointer;

                        .el-icon-download {
                            font-size: 20px;
                            margin-left: 7px;
                            font-weight: bold;
                        }
                    }

                    video {
                        margin-block: 8px 16px;
                        width: 320px;
                        height: 180px;
                        object-fit: contain;
                        background-color: black;
                    }
                }
            }
        }
    }

    &_privacy {
        height: 126px;
        // border-top: 1px solid #e9e9e9;
        padding-inline: 100px;
        position: relative;
        gap: 10px;

        .privacy-line {
            flex: 1;
            height: 1px;
            background-color: #d9d9d9;
        }

        .privacy-tip {
            flex: 1;
            padding: 14px 16px;
            background: #fff3f3;
            border-radius: 4px;
            border: 1px solid #ff1111;
            color: #ff1111;
            font-size: 14px;

            i {
                font-size: 16px;
            }
        }
    }

    .status-icon {
        position: absolute;
        top: 30px;
        right: 30px;
        width: 160px;
        height: 136px;
        object-fit: cover;
    }
}
</style>

<style lang="scss">
.submit-list {
    .submit-item {
        justify-content: space-between;
        height: 46px;
        padding-inline: 24px;

        & + .submit-item {
            border-top: 1px solid #e7e7e7;
        }

        &_label,
        &_time {
            font-weight: 400;
            font-size: 14px;
            color: rgba(51, 51, 51, 0.9);
        }

        &_label,
        &_btn {
            width: 20%;
        }

        &_btn {
            text-align: right;
        }
    }
}

.submit-history-popper {
    padding: 0;
}
</style>
